import React, { useState, useEffect } from 'react';
import '../styles/login.css';

import titleImage from '../assets/images/main-characters.png';
import loginImage from '../assets/images/login/Btn_Login.png';
import sendImage from '../assets/images/login/Btn_Send.png';
import loginPanelImage from '../assets/images/login/Login_Box_Pop.png';
import logoImage from '../assets/images/login/Logo.png';
import connectWalletButtonImage from '../assets/images/login/ConnectWalletButton.png';

const API_BASE_URL = 'https://api.adena-fi.com/auth';

function Toast({ message, onClose }) {
  if (!message) return null;
  return (
    <div className="toast">
      {message}
      <button onClick={onClose} className="toast-close">
        ×
      </button>
    </div>
  );
}

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 이메일 로드
  useEffect(() => {
    const savedEmail = localStorage.getItem('userEmail');
    if (savedEmail) {
      setEmail(savedEmail);
    }
  }, []);

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => {
      setToastMessage('');
    }, 3000); // 3초 후 자동 닫힘
  };

  const sendAuthCode = async () => {
    if (!email) {
      showToast('Please enter your email address.');
      return;
    }
    showToast('Sending authentication code...');
    setLoading(true);
    try {
      const version = 'web-1.0.1';
      const response = await fetch(`${API_BASE_URL}/send-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, version }),
      });
      if (!response.ok) throw new Error('Failed to send authentication code.');
      setIsCodeSent(true);
      showToast('Authentication code sent successfully.');
    } catch (err) {
      showToast(err.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyAuthCode = async () => {
    if (!authCode) {
      showToast('Please enter the authentication code.');
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/verify-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          code: authCode,
          client_type: 'web',
          platform: 'web',
          app_version: 'web-1.0.1',
        }),
      });

      if (!response.ok) throw new Error('Invalid or expired authentication code.');

      const data = await response.json();
      const { access_token } = data;

      if (!access_token) {
        throw new Error('Authentication token not provided.');
      }

      // authToken을 로컬 스토리지에 저장
      localStorage.setItem('authToken', access_token);
      localStorage.setItem('userEmail', email); // 이메일 저장

      showToast('Login successful!');
      setIsLoggedIn(true); // 로그인 완료 상태로 전환

      // 로그인 후 처리
      onLogin(); // 부모 컴포넌트에서 상태 관리
    } catch (err) {
      showToast(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      {!isLoggedIn ? (
        <>
          <div className="title">
            <img className="titleImage" src={titleImage} alt="THE ADENA" />
          </div>
          <div className="login-container">
            <div className="login-panel">
              <img src={loginPanelImage} alt="Login Panel" />
            </div>
            <div className="login-content">
              <div className="input-group">
                {/* 이메일 입력 필드 */}
                <div className="email-group">
                  <input
                    type="email"
                    placeholder="Enter your email address..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input"
                    disabled={isCodeSent || loading}
                  />
                </div>

                {/* 인증 코드 입력 필드 */}
                <div className="auth-code-group">
                  <input
                    type="text"
                    placeholder="Enter auth code..."
                    value={authCode}
                    onChange={(e) => setAuthCode(e.target.value)}
                    className="input"
                    disabled={!isCodeSent || loading}
                  />
                  <button
                    onClick={sendAuthCode}
                    className="send-button"
                    disabled={loading || !email || isCodeSent}
                    style={{ backgroundImage: `url(${sendImage})` }}
                  >
                    {loading && !isCodeSent ? 'Sending...' : ''}
                  </button>
                </div>

                {/* 로그인 버튼 */}
                <div className="login-group">
                  <button
                    onClick={verifyAuthCode}
                    className="button"
                    disabled={loading || !authCode || !isCodeSent}
                    style={{ backgroundImage: `url(${loginImage})` }}
                  >
                    {loading && isCodeSent ? 'Verifying...' : ''}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="logo-container">
          <img src={logoImage} alt="Logo" className="logo" />
          <button
            onClick={onLogin}
            className="connect-wallet-button"
            style={{
              backgroundImage: `url(${connectWalletButtonImage})`,
            }}
          />
        </div>
      )}
      <Toast message={toastMessage} onClose={() => setToastMessage('')} />
    </div>
  );
}

export default LoginPage;
